import React from 'react'; 
import {injectIntl} from 'react-intl';
import ToolHeader from '../common_components/ToolHeader';

@injectIntl
export default class Header extends React.Component{

  render(){ 

    return(
      <ToolHeader name={this.props.intl.formatMessage({id: 'igbusiness'}).toUpperCase()} />
    );
  }

}